import React from "react"
import "./pages.css"
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Login from "../user/login";
import SighnUp from "../user/sighnUp";

const LoginAndSighnUp = ()=>{
    const params = useParams().id
    return(
        <Container>
            <Row>
                <Col sm={6}></Col>
                {
                params === "Login" && 
                    <Login />
                }
                {
                params === "SigneUp" && 
                    <SighnUp />
                }
                
            </Row>
            {/* {params} */}
        </Container>
    )
}

export default LoginAndSighnUp